<template>
  <div id="login">
    <div class="inner">
      <h1>
        <img src="@/assets/img/logo_edit_bk.png" alt="iSTAY" />
      </h1>
      <form @submit.prevent="onSubmit">
        <div class="uid"><input type="text" class="input" placeholder="id" v-model="uid" required></div>
        <div class="upw"><input type="password" class="input" placeholder="password" v-model="password" required></div>
        <div><button type="submit" class="btn btnFull btnPrimary">LOGIN</button></div>
        <p class="version">{{`v.${service.version}_${service.updated}`}}</p>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Login',
  props: [
    'locale'
  ],
  computed: {
    service () {
      return {
        version: this.$store.state.service.version,
        updated: this.$store.state.service.updated
      }
    },
    partner () {
      return this.$store.state.service.partner
    },
    isLogin () {
      return this.$store.getters['authentication/isLogin']
    },
    isBlank () {
      return this.uid.trim().length === 0 || this.password.trim().length === 0
    }
  },
  created () {
    const loginUid = localStorage.getItem('loginUid')
    this.$store.commit('onLoading', false)
    this.uid = loginUid && loginUid !== 'null' ? loginUid : ''
    if (this.isLogin) {
      this.$router.replace({
        path: '/'
      })
    } else {
      this.$store.commit('setting/init')
      this.$store.commit('menu/updateList')
      this.$store.commit('floating/init')
      this.$store.commit('coupon/couponData', [])
      this.$store.commit('coupon/initSetInfo')
      this.$router.replace({
        path: '/login'
      })
    }
  },
  data () {
    return {
      uid: '',
      password: '',
      message: false
    }
  },
  methods: {
    validateOnSubmit () {
      if (this.isBlank) {
        return false
      } else {
        return true
      }
    },
    async onSubmit () {
      const locale = this.locale
      const isPassed = this.validateOnSubmit()
      const data = {
        uid: this.uid,
        pw: this.password
      }
      if (isPassed) {
        this.$store.commit('onLoading', true)
        const res = await this.$store.dispatch('authentication/login', data)
        if (res?.status === 200) {
          this.$router.replace({
            path: '/'
          })
        } else {
          const status = res?.data?.message?.code || res?.data?.status || 500
          const errMessage = res?.data?.message || res?.data?.message?.message || 'unknown error'
          const errReason = res?.data?.message?.reason
          if (status === 301) {
            // this.message = this.locale.err_id_pw
            alert(this.locale.alert_incorrect_pw)
          } else if (status === 201 || status === 202) {
            if (status === 201) alert(`${this.locale.change_pw_desc}\n${this.locale.change_pw_security_policy}`)
            if (status === 202) alert(`${this.locale.change_pw_more_than}\n${this.locale.change_pw_desc}`)
            sessionStorage.setItem('tempUserId', this.uid)
            this.$router.push({
              name: 'change_password',
              params: {
                code: `${status}`
              }
            })
          } else {
            alert(`[${status}] ${errMessage}${errReason ? ': ' + errReason : ''}`)
          }
        }
        this.$store.commit('onLoading', false)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
#login {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
  padding: 5% 5% 10%;
  font-size: 1.2em;
  h1 {
    margin-bottom: 48px;
    text-align: center;
    p {
      font-size: 0.8em;
      color: $color-grey;
    }
    img {
      width: 260px;
      &[src*='coreguide'] {
        width: auto;
      }
    }
  }
  .uid {
    margin-bottom: 8px;
  }
  .upw {
    margin-bottom: 48px;
  }
  .input {
    border-radius: 50px;
  }
  .btn {
    border-radius: 20px;
  }
  .inner {
    position: relative;
    width: 100%;
    max-width: 420px;
    padding: 30px;
    text-align: center;
  }
}
.version {
  margin-top: 1em;
  font-size: 0.8em;
  color: $color-grey;
  opacity: 0.7;
}
@media screen and (max-width: 670px) {
  #login {
    .inner {
      padding: 60px 30px;
    }
    h1 {
      img {
        width: 160px;
      }
      p {
        font-size: 12px;
      }
    }
  }
  .version {
    font-size: 12px;
  }
}
@media screen and (max-width: 480px) {
  #login {
    font-size: 1em;
    .inner {
      padding: 60px 15px 45px;
    }
  }
}
</style>
